import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HomeAdminsCard from "../../components/cards/HomeAdminsCard";
import HomeStatsCard from "../../components/cards/HomeStatsCard";
import HonorBoardCard from "../../components/cards/HonorBoardCard";
import TotalCoursesCard from "../../components/cards/TotalCoursesCard";
import ViewsHoursCard from "../../components/cards/ViewsHoursCard";
import { useGetAdminDashboardStatsQuery } from "../../services/organization/adminStatistics";
import { useGetAdminLeaderboardQuery } from "../../services/organization/leaderboard";
import InviteEmployeeModal from "../../components/Modals/InviteEmployeeModal";
import LoadingIndicator from "../../components/LoadingIndicator";

const Home = () => {
  const { data: dashboardStats, isLoading: isDashboardStatsLoading } =
    useGetAdminDashboardStatsQuery();
  const { data: leaderboardUsers, isAdminLeaderboardLoading } =
    useGetAdminLeaderboardQuery({
      page: 1,
      perPage: 3,
    });

  let navigate = useNavigate();
  const { t } = useTranslation(["common", "learningPaths"]);

  if (isDashboardStatsLoading || isAdminLeaderboardLoading)
    return <LoadingIndicator />;

  return (
    <div className="admin-home">
      <InviteEmployeeModal />

      <header className="admin-home__toolbar">
        <div className="admin-home__intro">
          <h1 className="title-page font_24 mb-0">{t("homepage")}</h1>
        </div>

        <div className="admin-home__actions">
          <button
            type="button"
            className="btn btn-main-color-border font-15"
            onClick={() => navigate("/admin/learning_paths/new")}
          >
            <span className="fas fa-plus fa-fw me-2"></span>
            {t("learningPaths:createNewLearningTrack")}
          </button>
          <button
            type="button"
            className="btn btn-main-color font-15"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            <span className="fas fa-user-plus fa-fw me-2"></span>
            {t("inviteNewEmployee")}
          </button>
        </div>
      </header>

      <div className="container-fluid admin-home__body">
        <div className="row admin-home__grid g-3">
          <div className="col-12 col-lg-6">
            <ul className="row g-3">
              <li className="col-6 col-sm-6">
                <HomeStatsCard
                  bgColor="rgba(157, 78, 221, 0.06)"
                  img="graduation-cap-solid.svg"
                  title={t("learningTracksCount")}
                  num={dashboardStats?.data?.learning_tracks_count}
                  singleNumber
                />
              </li>
              <li className="col-6 col-sm-6">
                <HomeStatsCard
                  bgColor="rgba(241, 115, 0, 0.06)"
                  img="courses.svg"
                  title={t("coursesCount")}
                  num={dashboardStats?.data?.total_courses}
                  singleNumber
                />
              </li>
              <li className="col-6 col-sm-6">
                <HomeStatsCard
                  bgColor="rgba(136, 136, 136, 0.06)"
                  img="invitationsNumber.svg"
                  title={t("pendingInvitationsCount")}
                  num={dashboardStats?.data?.invites_count}
                  singleNumber
                />
              </li>
              <li className="col-6 col-sm-6">
                <HomeStatsCard
                  bgColor="rgba(1, 194, 153, 0.06)"
                  img="acceptedUsers.svg"
                  title={t("acceptedInvitationsCount")}
                  num={dashboardStats?.data?.registers_count}
                  singleNumber
                />
              </li>
            </ul>
          </div>
          <div className="col-12 col-lg-6">
            <ul className="row g-3">
              <li className="col-12">
                <TotalCoursesCard
                  completedCourses={
                    dashboardStats?.data?.completed_course_enrollments
                  }
                  totalCourses={dashboardStats?.data?.total_course_enrollments}
                />
              </li>
              <li className="col-12">
                <HomeAdminsCard
                  totalUsersNumber={dashboardStats?.data?.total_number_of_users}
                />
              </li>
            </ul>
          </div>
          <div className="col-12 col-lg-6">
            <ViewsHoursCard
              watchingPercentage={dashboardStats?.data?.watching_percentage}
            />
          </div>
          <div className="col-12 col-lg-6">
            <HonorBoardCard leaderboardUsers={leaderboardUsers?.data} isAdmin />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
